import { render, staticRenderFns } from "./CvProfile.vue?vue&type=template&id=88e90acc"
import script from "./CvProfile.vue?vue&type=script&lang=js"
export * from "./CvProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports